<template>
  <div>
    <b-alert
      v-testid="'toast-notification-region'"
      :show="dismissSecs === -1 || dismissCountDown"
      :dismissible="notification.dismissible"
      fade
      :variant="notification.type"
      class="mb-0"
      :class="notification.class"
      @dismiss-count-down="countDownChanged"
      @dismissed="removeNotification"
    >
      <fa-icon
        v-if="notification.icon"
        :class="notification.icon.class"
        :icon="notification.icon.icon"
        :size="notification.icon.size"
        :style="notification.icon.style"
      />
      <span :class="notification.text ? notification.text.class : null">
        <!-- eslint-disable-next-line vue/no-v-html -->
        <span v-if="notification.message && notification.isHtmlMessage" v-html="notification.message" />
        <span v-else>{{ notification.message }}</span>
      </span>
    </b-alert>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'NotificationBar',
  props: {
    notification: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      // If dismissSecs = -1 (Infinite)
      dismissSecs: this.notification?.dismissSecs || 5,
      dismissCountDown: 0,
    };
  },
  watch: {
    dismissCountDown: function (value) {
      if (value === 0 && this.notification.callback) this.notification.callback(this.notification.$callback);
    },
  },
  mounted() {
    this.showAlert();
  },
  methods: {
    ...mapActions('notification', ['remove']),
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    removeNotification() {
      this.remove(this.notification);
    },
  },
};
</script>

<style lang="scss" scoped></style>
